module.exports = __webpack_public_path__ + "static/0-27112d41826ccfa74f31302bc610ede1.png";